import React, { useEffect } from 'react';
import { Button, ButtonBaseProps, TextField } from '@mui/material';
import fetch from 'cross-fetch';
import { AccountApiResponse, CommonPageStep, SignupPageStep } from '../..';
import { verifyDataFormat } from '../../../common/CommonTools';
import { appConfig } from '../../../common/ConfigLoader';
import { useAppSelector } from '../../../store/hooks';
import { setAppPageStep } from '../../../store/reducer/appStateSlice';
import {
  selectSignupData,
  setSignupData,
} from '../../../store/reducer/signupDataSlice';
import { outsideComponentDispatch } from '../../../store/store';

export interface LoginElementInterface {
  emailInput: JSX.Element;
  continueButton: JSX.Element;
  loginRedirectButtonClickHandler: () => void;
  backButtonClickHandler: () => void;
}

export const CreateParentAccountElement = () => {
  // Redux
  const signupData = useAppSelector(selectSignupData);

  // Local Hooks
  const [emailInputError, setEmailInputError] = React.useState<string>();

  // Handlers
  const createAccountNextButtonClickHandler = (): void => {
    const url = `${appConfig().accountServer}user/UsernameVerify`;
    const jsonData = {
      username: signupData.username,
    };
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(jsonData),
    })
      .then(async (res): Promise<void> => {
        const result = (await res.json()) as AccountApiResponse;
        if (result.success === undefined) {
          outsideComponentDispatch(
            setAppPageStep(SignupPageStep.CREATE_PARENT_PROFILE),
          );
        }

        setEmailInputError(
          'Email has already signed up. Please enter an different email.',
        );
      })
      .catch((err) => {
        console.debug('API ERROR', url, err);
      });
  };

  useEffect(() => {
    const keyDownHandler = (event: KeyboardEvent): void => {
      if (event.key === 'Enter') {
        event.preventDefault();
        createAccountNextButtonClickHandler();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return (): void => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  const createAccountBackButtonClickHandler = (
    event: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    console.log('Redirecting to /CreatePartnershipProfile');
    window.location.href = '/CreatePartnershipProfile';
  };

  return {
    emailInput: (
      <TextField
        fullWidth={true}
        sx={{ width: 'inherit' }}
        color={'primary'}
        error={emailInputError !== undefined}
        variant="outlined"
        type="email"
        label="Email Address"
        size="medium"
        margin="none"
        defaultValue={signupData.username}
        helperText={emailInputError}
        onChange={(event): void => {
          if (!verifyDataFormat(event.target.value, { type: 'EMAIL' })) {
            setEmailInputError('Invalid email.');
            outsideComponentDispatch(
              setSignupData({ dataKey: 'username', data: '' }),
            );
            return;
          }

          setEmailInputError(undefined);
          outsideComponentDispatch(
            setSignupData({
              dataKey: 'username',
              data: event.target.value.toLowerCase(),
            }),
          );
        }}
        name="email"
      />
    ),
    continueButton: (
      <Button
        id="create-account-main-group-content-next-button"
        variant="contained"
        disabled={emailInputError !== undefined || signupData.username === ''}
        onClick={createAccountNextButtonClickHandler}
        fullWidth={true}
        sx={{ width: 'inherit' }}
      >
        continue
      </Button>
    ),
    loginRedirectButtonClickHandler() {
      // Only visible on DesktopView
      // window.location.href = '/Login';
      // To-do: add transition animation
      outsideComponentDispatch(setAppPageStep(CommonPageStep.LOGIN));
    },
    backButtonClickHandler() {
      // To-do: add transition animation
      outsideComponentDispatch(setAppPageStep(CommonPageStep.LOGIN));
      // USING REDUX INSTEAD
      // window.location.href = '/Entry';
    },
  };
};
